import { useState, useCallback } from 'react';
import { GameSession, PlayerInfo } from '../types/game';
import { Socket } from 'socket.io-client';

export const useGameSession = (socket: Socket | null) => {
  const [session, setSession] = useState<GameSession | null>(null);
  const [player, setPlayer] = useState<PlayerInfo | null>(null);
  const [opponent, setOpponent] = useState<PlayerInfo | null>(null);
  const [isWaiting, setIsWaiting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const joinQueue = useCallback((playerName: string) => {
    if (socket) {
      setError(null);
      setIsWaiting(true);
      socket.emit('join-queue', playerName);
    }
  }, [socket]);

  const makeMove = useCallback((position: number) => {
    if (socket && session && player) {
      socket.emit('make-move', { sessionId: session.id, position });
    }
  }, [socket, session, player]);

  const nextRound = useCallback(() => {
    if (socket && session) {
      socket.emit('next-round', { sessionId: session.id });
    }
  }, [socket, session]);

  const resetGame = useCallback(() => {
    setSession(null);
    setPlayer(null);
    setOpponent(null);
    setIsWaiting(false);
    setError(null);
  }, []);

  return {
    session,
    player,
    opponent,
    isWaiting,
    error,
    joinQueue,
    makeMove,
    nextRound,
    resetGame,
    setSession,
    setPlayer,
    setOpponent,
    setIsWaiting,
    setError
  };
};